export const docsUrl = (path) => `https://www.navidrome.org${path}`
